import { withLatestFrom, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { DetailsSidebarAction, detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { SymbolSyntheticAction } from '@cbridge-packages/symbol-synthetic';

type IState =
  IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeSyntheticSymbolBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { symbolId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);
    if (openedDetailsId === symbolId) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
